// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__qIeDG","col":"styles_col__OVZXy"};